module.exports = __webpack_public_path__ + "img/Feature.e97d8bfb.jpg";